import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
// import Alert from "react-bootstrap/Alert";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";
import {
  fetchIncentivesSlabsData,
  fetchIncentivesStatsData,
  fetchTrainerIncentivesData,
} from "../../../redux/incentives-reducers/incentivesSlice";
import IncentiveCatTabs from "./IncentiveCatTabs";
import IncentiveTargetForm from "./targets/IncentiveTargetForm";
import CommonStructured from "../../common-components/CommonStructured";
import IncentiveSlabForm from "./slabs/IncentiveSlabForm";
import IncentiveStatCards from "./rainer-incentives/IncentiveStatCards";
import {
  currentMonthName,
  currentMonthNumber,
} from "../../common-data/Converts";
import { currentYearNo } from "../../common-data/DropdowData";
import ApplicableSubscriptions from "./rainer-incentives/ApplicableSubscriptions";
import WelcomeUser from "../../Open-pages/user/WelcomeUser";

const IncentiveStructure = ({
  userInfoData,
  isCustom,
  // isNotificationDenied,
}) => {
  const dispatch = useDispatch();

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedTrainer:
      !isAdmin && !isClusterManager
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    selectedMonth: {
      label: currentMonthName,
      value: currentMonthNumber,
    },
    selectedYear: {
      label: currentYearNo,
      value: currentYearNo,
    },
    selectedSlab: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    month: allFilters.selectedMonth?.value || "",
    year: allFilters.selectedYear?.value || "",
    slab_id: allFilters.selectedSlab?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    setIsPage(0);
  };

  function onResetFilters() {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
    setIsPage(0);
  }

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function onClickAddBtn(name, row) {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      cardName: name,
      rowData: row,
    }));
  }

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  function getIncentivesStats(filters) {
    const { page, limit, ...rest } = filters;

    dispatch(
      fetchIncentivesStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getIncentivesSlabs(filters) {
    const { page, limit } = filters;

    dispatch(
      fetchIncentivesSlabsData({
        filters: { page, limit },
        token: userInfoData?.token,
      })
    );
  }

  function getTrainerIncentives(filters) {
    dispatch(
      fetchTrainerIncentivesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      month: allFilters.selectedMonth?.value || "",
      year: allFilters.selectedYear?.value || "",
      slab_id: allFilters.selectedSlab?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.selectedMonth,
    allFilters.selectedYear,
    allFilters.selectedSlab,
  ]);

  useEffect(() => {
    getIncentivesStats(filters);
    getTrainerIncentives(filters);
  }, [filters]);

  useEffect(() => {
    if (selectedTab === 1 && isAdmin) {
      getIncentivesSlabs(filters);
    }
  }, [filters.page, filters.limit, selectedTab]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <Container className="bg-cloud-k px-50px gobal-container" fluid>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="PT Incentives Modal"
        ariaHideApp={false}
      >
        {modValues.cardName === "add-target" ||
        modValues.cardName === "edit" ? (
          <IncentiveTargetForm
            userInfoData={userInfoData}
            callFunction={() => {
              getTrainerIncentives(filters);
            }}
            closeModal={onCloseModal}
            isEdit={modValues.cardName === "edit"}
            rowData={modValues.rowData}
          />
        ) : modValues.cardName === "add-slab" ||
          modValues.cardName === "edit-slab" ? (
          <IncentiveSlabForm
            userInfoData={userInfoData}
            isEdit={modValues.cardName === "edit-slab"}
            rowData={modValues.rowData}
            closeModal={onCloseModal}
            callFunction={() => getIncentivesSlabs(filters)}
          />
        ) : modValues.cardName === "applicable-subscriptions" ? (
          <ApplicableSubscriptions
            userInfoData={userInfoData}
            rowData={modValues.rowData}
            onCloseModal={onCloseModal}
            prevFilters={filters}
          />
        ) : null}
      </Modal>

      {isCustom && (
        <Row>
          <Col>
            <WelcomeUser userName={userInfoData?.name} />
            {/* {isNotificationDenied === "denied" && (
              <Alert variant={"danger"} className="mt30">
                Notification permission is denied. Unable to display desktop
                notifications.
              </Alert>
            )} */}
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <CommonStructured
            isCustom={isCustom}
            pageHeading={"Trainer Incentives"}
            createBtnTxt={isAdmin ? "+ Add New Slab" : ""}
            onClickCreateBtn={() =>
              isAdmin ? onClickAddBtn("add-slab") : null
            }
            isReload={() => {
              getIncentivesStats(filters);
              getTrainerIncentives(filters);
              isAdmin && getIncentivesSlabs(filters);
            }}
          />
        </Col>
      </Row>

      {selectedTab === 0 && (
        <Row>
          <Col>
            <CommonFilterStructure
              from={"pt-incentives"}
              decryptedText={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
            />

            <IncentiveStatCards userInfoData={userInfoData} />
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <IncentiveCatTabs
            text={"All Incentives"}
            selectedTab={selectedTab}
            handleTabSelect={handleTabSelect}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            userInfoData={userInfoData}
            callFunction={() => {
              if (selectedTab === 1) {
                getIncentivesSlabs(filters);
              } else if (selectedTab === 2) {
                getTrainerIncentives(filters);
              } else {
                getIncentivesStats(filters);
              }
            }}
            onClickAddBtn={onClickAddBtn}
            isAdmin={isAdmin}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default IncentiveStructure;
